import * as TYPES from './type';
export default {
  //课中活动讨论
  [TYPES.Talk_LIST](state, { result, type }) {
    state.talkList = result.result
  },
  [TYPES.Talk_INFO](state, { result, type }) {
    state.talkInfo[type] = result.result
  },
}


// WEBPACK FOOTER //
// ./src/store/kzActivity/discuss/mutations.js